import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setCurrentCourse, setCurrentPage, setResultTypeAmount } from "../../../store/actions/mainActions";
import SearchBox from "../../core/SearchBox/SearchBox";
import "./Search.scss";
import { SearchItem } from "../../content/Search/SearchResult/SearchItem";
import postItemService from "../../../Axios/services/postItem.service";
import { PostItem } from "../../../../../entities/build/src/Content";
import { resultTypeAmount, ResultTypeAmount } from "../../../store/reducers/mainReducer";
import { useSelector } from "react-redux";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { FeedEventItem } from "../../content/Feed/FeedEventItem/FeedEventItem";
import FeedSessionItem from "../../content/Feed/FeedSessionItem/FeedSessionItem";
import { useParams, useNavigate } from "react-router-dom";

export const Search = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { term } = useParams();

  const initialSearchInput = term || "";
  const [searchInput, setSearchInput] = useState(initialSearchInput);
  const [searchResult, setSearchResult] = useState<PostItem[] | undefined>(undefined);
  const [filteredSearchResult, setFilteredSearchResult] = useState<PostItem[] | undefined>(undefined);
  const { me } = useSelector((state: any) => state.auth);
  const { searchFilter } = useSelector((state: any) => state.main);

  const onEnter = (e: any) => {
    setSearchResult(undefined);
    navigate("/search/" + searchInput);
  };

  const searchHandler = (event: any) => {
    setSearchInput(event.target.value);
  };

  useEffect(() => {
    const filteredSearchResult: PostItem[] | undefined = [];
    if (searchFilter && searchFilter !== "reset") {
      if (searchResult) {
        searchResult.map((s) => {
          if (searchFilter.indexOf(s.content?.type) !== -1) filteredSearchResult.push(s);
          else if (s.eventContentItem?.type === searchFilter) filteredSearchResult.push(s);
          else if (s.sessionContentItem?.type === searchFilter) filteredSearchResult.push(s);
          return s;
        });
        setFilteredSearchResult(filteredSearchResult);
      }
    } else {
      setFilteredSearchResult(searchResult);
    }
  }, [searchFilter, searchResult]);

  const search = useCallback(async () => {
    const extractAmount = (result: PostItem[]) => {
      const newResultTypeAmount: ResultTypeAmount[] = [...resultTypeAmount.map((r: ResultTypeAmount) => ({ ...r }))];
      result.map((p) => {
        if (p?.content?.type === "hartman_link" || p?.content?.type === "external_link") {
          newResultTypeAmount[0].amount++;
          newResultTypeAmount[0].originalType = "hartman_link,external_link";
        } else if (p?.content?.type === "sefaria_link") {
          newResultTypeAmount[1].amount++;
          newResultTypeAmount[1].originalType = "sefaria_link";
        } else if (p?.eventContentItem?.type === "event") {
          newResultTypeAmount[2].amount++;
          newResultTypeAmount[2].originalType = "event";
        } else if (p?.sessionContentItem?.type === "session") {
          newResultTypeAmount[3].amount++;
          newResultTypeAmount[3].originalType = "session";
        }
        return p;
      });
      return newResultTypeAmount;
    };

    try {
      if (me?._id) {
        const posts = await postItemService.searchPosts(me._id, term);
        const searchResult = false ? posts.filter((p) => p.post.toLowerCase().includes(term.toLowerCase())) : posts;
        const newResultTypeAmount = extractAmount(searchResult);
        dispatch(setResultTypeAmount(newResultTypeAmount));
        setSearchResult(searchResult);
      }
    } catch (err) {
      console.error(err);
    }
  }, [term, dispatch, me]);

  useEffect(() => {
    dispatch(setCurrentPage("search"));
    search();
    return () => {
      dispatch(setResultTypeAmount(resultTypeAmount));
      dispatch(setCurrentPage(""));
    };
  }, [dispatch, search]);

  return (
    <>
      searchResult ? (
      <div className="container-fluid my-feed">
        <div className="mx-md-0 mb-4">
          <SearchBox
            placeholder={"Find event, Member, post or hashtag..."}
            changeHandler={searchHandler}
            onEnter={onEnter}
            value={searchInput}
            classes="blue-border"
            iconColor="i-color"
          />
        </div>
        <div className="col-12 i-count">{searchResult.length} Items were found</div>
        {filteredSearchResult && filteredSearchResult.length > 0 ? (
          filteredSearchResult?.map((item: any, index: number) => {
            if (item?.eventContentItem && item?.sessionContentItem) {
              return (
                <>
                  <div key={index + 1}>
                    <FeedEventItem item={item}></FeedEventItem>
                  </div>
                  <div key={index + 2}>
                    <FeedSessionItem item={item}></FeedSessionItem>
                  </div>
                </>
              );
            } else if (item?.eventContentItem) {
              return (
                <div key={index}>
                  <FeedEventItem item={item}></FeedEventItem>
                </div>
              );
            } else if (item?.sessionContentItem) {
              return (
                <div key={index}>
                  <FeedSessionItem item={item}></FeedSessionItem>
                </div>
              );
            } else {
              return (
                <div key={index}>
                  <SearchItem item={item} />
                </div>
              );
            }
          })
        ) : (
          <div className="row my-5">
            <div className="col-12">No results</div>
          </div>
        )}
        <div className="space"></div>
      </div>
      ) : (
      {Array.from(Array(4).keys()).map((e, i) => {
        return (
          <div className="feed-item py-3 px-5" key={i}>
            <SkeletonTheme>
              <div className="row flex-wrap">
                <div className="col-2 d-flex justify-content-center">
                  <Skeleton circle={true} height={60} width={60} />
                </div>
                <div className="col-10">
                  <p className="m-0 p-0">
                    <Skeleton height={10} width={150} />
                  </p>
                  <p className="m-0 p-0">
                    <Skeleton height={10} width={180} />
                  </p>
                  <p className="m-0 p-0">
                    <Skeleton height={10} width={80} />
                  </p>
                </div>
              </div>
            </SkeletonTheme>
          </div>
        );
      })}
      )
    </>
  );
};
